const generateUniqueBatchID = () => {
  return Date.now().toString();
}

export default generateUniqueBatchID;
